<template>
  <auth-shell
    :title="$t('auth.forgot.title')"
    :subtitle="$t('auth.forgot.sub')"
    :back-label="$t('auth.backLogin')"
    icon="fal fa-key"
    icon-tone="soft"
  >
    <form class="ps-auth-form" novalidate @submit.prevent="submitForm(form)">
      <div class="ps-field">
        <label class="ps-field__label" for="vaEmail">{{
          $t("auth.forgot.account")
        }}</label>
        <input
          id="vaEmail"
          v-model="form.email"
          type="text"
          required
          :placeholder="$t('auth.forgot.accountPh', { at: '@' })"
          class="ps-input"
          :disabled="overlay"
          @input="$v.form.email.$touch()"
          @blur="$v.form.email.$touch()"
        />
        <p v-if="emailError.length" class="ps-field__error">
          {{ emailError[0] }}
        </p>
      </div>

      <button
        type="submit"
        class="ps-btn ps-btn--brand ps-btn--block ps-auth-submit"
        :disabled="overlay"
      >
        {{ overlay ? "…" : $t("auth.forgot.submit") }}
      </button>
    </form>

    <p class="ps-auth-switch">
      {{ $t("auth.forgot.remember") }}
      <router-link to="/login" class="ps-auth-switch__link">{{
        $t("auth.forgot.login")
      }}</router-link>
    </p>

    <app-loading :overlay="overlay" />
  </auth-shell>
</template>

<script>
import { toast } from "@/controllers/alert";
import AuthShell from "@/components/auth/AuthShell.vue";

import { required, email } from "vuelidate/lib/validators";
export default {
  name: "VerifyAccountPage",
  layout: "blank",
  components: { AuthShell },
  data: () => ({
    overlay: false,
    form: {
      email: "",
    },
  }),
  validations: {
    form: {
      email: {
        email,
        required,
      },
    },
  },
  computed: {
    emailError() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors;
      !this.$v.form.email.required &&
        errors.push(this.$t("validation_email_required"));
      !this.$v.form.email.email &&
        errors.push(this.$t("validation_email_invalid"));
      return errors;
    },
  },
  methods: {
    async submitForm(form) {
      try {
        this.$v.form.$touch();
        if (!this.$v.form.$invalid) {
          this.overlay = true;
          const { data } = await this.$http.post("verify", form);
          if (data.status) {
            await toast(this, data.message);
            this.overlay = false;
            this.$router.push({
              name: "VerifyNewUser",
              query: { email: form.email },
            });
          }
        }
      } catch (error) {
        this.overlay = false;
        console.log("submitForm ===> ", error);
      }
    },
  },
};
</script>

<style scoped>
.ps-auth-form {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ps-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ps-field__label {
  font-size: 0.875rem;
  font-weight: 900;
  color: var(--ps-ink);
}

.ps-field__error {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: #dc2626;
}

.ps-auth-submit {
  padding: 1rem;
}

.ps-auth-switch {
  margin: 24px 0 0;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--ps-slate-500);
}

.ps-auth-switch__link {
  color: var(--ps-brand);
  font-weight: 900;
  text-decoration: none;
}
.ps-auth-switch__link:hover {
  text-decoration: underline;
}
</style>
